// extracted by mini-css-extract-plugin
export default {"main-content":"Footer_main-content__Jj76t","Footer":"Footer_Footer__kqAXm","link":"Footer_link__NpKlm"};